import React, { useEffect, useState } from "react";
import FormFieldDescriptor from "./models/FormFieldDescriptor";
import BaseFormFieldProps from "./models/BaseFormFieldProps";
import { FormFieldsMap } from "./fields/FormFieldsMap";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import {
  fillExternalData,
  setDynamicFormValidationRules,
} from "./helpers/dynamicFormHelper";
import { usePrevious } from "features/shared/hooks/usePrevious";

type Props = {
  formJson: string;
  fieldProps: BaseFormFieldProps;
  externalData?: Record<string, any[]>;
};

const DynamicForm = ({ formJson, fieldProps, externalData }: Props) => {
  // state
  const [formFields, setFormFields] = useState<FormFieldDescriptor[]>([]);
  const prevFormFields = usePrevious(formFields);

  // side-effects
  useEffect(() => {
    let descriptors = JSON.parse(formJson) as FormFieldDescriptor[];

    if (descriptors.length > 0) {
      if (externalData) {
        fillExternalData(descriptors, externalData);
      }
      // remove previous validation rules
      if (prevFormFields && prevFormFields.length > 0) {
        setDynamicFormValidationRules(
          prevFormFields,
          fieldProps.formHandler.setValidationRule,
          "remove"
        );
      }

      // set validation rules
      setDynamicFormValidationRules(
        descriptors,
        fieldProps.formHandler.setValidationRule
      );

      // set form fields
      setFormFields(descriptors);
    }
  }, [formJson]);

  // sub-renders
  const renderFields = () => {
    let result: JSX.Element[] = [];

    for (let i = 0; i < formFields.length; i++) {
      const descriptor = formFields[i];
      const Field = FormFieldsMap[descriptor.type];

      if (Field !== undefined) {
        result.push(
          <React.Fragment key={`${descriptor.name}`}>
            <Field descriptor={descriptor} {...fieldProps} />
          </React.Fragment>
        );
      } else {
        console.warn(`Field with type '${descriptor.type}' doesn't exists.`);
      }
    }

    return result;
  };

  // render
  return (
    <RenderWrapper isVisible={() => formFields.length > 0}>
      {renderFields()}
    </RenderWrapper>
  );
};

export default DynamicForm;
